






import Vue from 'vue';

import OrganizationPeerGroupGoals from '@/views/authenticated/OrganizationPeerGroupGoals.vue';
import OrganizationLoadGuard from '@/components/OrganizationLoadGuard.vue';

export default Vue.extend({
  components: {
    OrganizationPeerGroupGoals,
    OrganizationLoadGuard
  },

  props: {
    organizationId: Number,
    peerGroupId: Number
  }
});
